import { createFileRoute } from "@tanstack/react-router";
import { MultiAgentPage } from "@/features/agents/pages/multi-agent-page";

// Thin shim: the multi-agent delegation (delegation-chain) drilldown is a static, read-only explainer — no
// search params, no data to prefetch — so it only mounts the feature page. Reached from the "Multi-agent
// delegation" card on the identity-type guide.
export const Route = createFileRoute("/_authed/tenants/$slug/agents/multi-agent")({
  component: MultiAgentPage,
});
